import { LoginForm } from "@/features/auth/LoginForm";

export function LoginPage() {
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-brand">FI Radar</div>
        <p className="auth-subtitle">Sign in to view your signals and strategies.</p>
        <LoginForm />
      </div>
    </div>
  );
}
